import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {translate} from '@jsverse/transloco';
import { UrlService } from 'src/app/services/util/url.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import {Router} from '@angular/router';
import {RouterSegments} from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { SubscriptionMgmtListComponent } from '../../subscription-mgmt-list/subscription-mgmt-list.component';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permission } from 'src/app/models/principal/permission';
import { FeatureService } from 'src/app/services/api/feature.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

const REQUIRED_PERMISSIONS = [
  Permission.DEPLOY_INGRESS_SERVICES,
];

@Component({
    selector: 'app-tenant-onboarding-details',
    templateUrl: './tenant-onboarding-details.component.html',
    styleUrls: ['./tenant-onboarding-details.component.scss'],
    standalone: false
})
export class TenantOnboardingDetailsComponent  implements OnInit {
  @Input() tenantData: any;
 private destroyRef = inject(DestroyRef);

  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  RouterSegments = RouterSegments;
  title: string;
  tenant: string;
  tenantDetailsData: any;
  featureList:any;

  constructor(private router: Router,
     public urlService: UrlService , private authService: AuthService,private sidenavService: SidenavService,public dateTimeFormatService: DateTimeFormatService, private tenantService: TenantService, private dialog: MatDialog, private permissionsService: PermissionsService, private featureService: FeatureService ,private toastrService: CustomToastrService) {
      
    }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.title = translate('TENANT_DETAILS.TENANT');
    this.tenant = this.authService.principal.provider;
    this.loadData();
   }

   loadData(): void {
    this.tenantService.getTenantDetails(this.tenantData.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetailsData = data;
    });
    this.featureService.getTenantIdFeatures(this.tenantData.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
      this.featureList = data;
    },(error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
   }

   openUrl(): void {
    this.urlService.openUrlInNewTab(`https://keycloak.shs.saas.temenos.cloud/admin/${this.tenantData.tenantId}/console/`);
   }

   closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

getZoneValue(feature?: any, zone?: string): boolean {
  const val = feature.dataZones?.find(z => z?.dataZone === zone)?.enabled;
  return val === 'true' || val === true;
}

getZoneModifiable(feature?: any, zone?: string): boolean {
  const val = feature.dataZones?.find(z => z?.dataZone === zone)?.modifiable;
  return val === 'true' || val === true;
}

}

